<template>
  <div>
    <div v-if="gelenval" class="chip">{{ gelenval }}</div>
  </div>
</template>
<script>
import { BBadge } from "bootstrap-vue";
export default {
  components: {
    BBadge,
  },
  data() {
    return {
      gelenval: "",
    };
  },
  methods: {
    gelenData() {
      this.gelenval = this.params.value;
    },
  },
  created() {
    this.gelenData();
  },
};
</script>
<style lang="scss">
.chip {
  display: inline-block;
  padding: 0 25px;
  height: 25px;
  font-size: 10px;
  line-height: 25px;
  border-radius: 25px;
  background-color: #7367f0;
  color: white;
}
</style>